import { render, staticRenderFns } from "./RadioButtonWrapper.vue?vue&type=template&id=15f2eeee&"
import script from "./RadioButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./RadioButtonWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports